<template>
  <a
    :href="category.url"
    :style="linkStyle"
    class="help-center-post-category__link"
  >
    {{ category.title }}
  </a>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  category: {
    type: Object,
    required: true
  }
})

const linkStyle = computed(() => {
  return {
    '--base-color': props.category.badge_color
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-category {
  &__link {
    @include help-center-link;
    @include help-center-font(12);

    font-weight: var(--help-center-bold);
    text-transform: uppercase;

    --base-color: var(--help-center-highlight);
    --darker-color: color-mix(in srgb, var(--base-color), black 5%);
    --darkest-color: color-mix(in srgb, var(--base-color), black 10%);

    color: white;
    padding: 4px 8px;
    border-radius: 12px;

    background-color: var(--base-color);
    transition: base-color 0.2s ease;

    &:hover,
    &:focus {
      background-color: var(--darker-color);
    }

    &:active {
      background-color: var(--darkest-color);
    }
  }
}
</style>
